import React, { useMemo, useState } from "react";
import { Drawer, Box, Typography, Stack, Alert } from "@mui/material";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import InfoRow from "../../../../components/atoms/InfoRow";
import FormTextField from "../../../../components/atoms/FormTextField";
import DrawerHeader from "../../../../components/atoms/DrawerHeader";
import DrawerFooter from "../../../../components/atoms/DrawerFooter";
import { COLORS, TYPO } from "../../../../styles/uiConstants";

export default function GetReturnDrawer({
  open,
  onClose,
  clinic,
  currentBalance = 0,
  onSubmit,
  isLoading,
}) {
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");

  const postOpBalance = useMemo(() => {
    const a = Number(amount);
    if (!a) return null;
    return currentBalance - a;
  }, [amount, currentBalance]);

  const isOverdraft = postOpBalance !== null && postOpBalance < 0;
  const canSubmit = Number(amount) > 0 && reason.trim() && !isOverdraft;

  const handleSubmit = () =>
    onSubmit({ amount: Number(amount), reason: reason.trim() });

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: { xs: "100%", sm: 440 } } }}
    >
      <DrawerHeader
        icon={<CurrencyExchangeIcon />}
        title="Token İadesi"
        subtitle={`${clinic?.name || ""} · Mevcut bakiye: ${currentBalance.toLocaleString("tr-TR")} token`}
        onClose={onClose}
        bgcolor={COLORS.error}
      />

      <Stack spacing={0} sx={{ p: 0, flex: 1, overflowY: "auto" }}>
        <InfoRow label="İade Miktarı (token)">
          <FormTextField
            variant="standard"
            InputProps={{ sx: { fontSize: TYPO.body } }}
            type="number"
            fullWidth
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            inputProps={{ min: 1, max: currentBalance }}
          />
        </InfoRow>
        {postOpBalance !== null && (
          <InfoRow label="İşlem Sonrası Bakiye">
            <Typography
              sx={{
                fontSize: TYPO.body,
                fontWeight: 600,
                color: isOverdraft ? "error.main" : "inherit",
              }}
            >
              {postOpBalance.toLocaleString("tr-TR")} token
            </Typography>
          </InfoRow>
        )}
        {isOverdraft && (
          <Box sx={{ px: 2.5, pb: 1 }}>
            <Alert severity="error">
              İade miktarı mevcut bakiyeyi aşıyor. Daha düşük bir miktar girin.
            </Alert>
          </Box>
        )}
        <InfoRow label="Sebep">
          <FormTextField
            variant="standard"
            InputProps={{ sx: { fontSize: TYPO.body } }}
            multiline
            fullWidth
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            inputProps={{ maxLength: 500 }}
            placeholder="İade sebebini belgeleyin"
          />
        </InfoRow>
      </Stack>

      <DrawerFooter
        onCancel={onClose}
        onSubmit={handleSubmit}
        submitLabel="İadeyi Onayla"
        loading={isLoading}
        disabled={!canSubmit}
        submitColor="error"
        fullWidth
      />
    </Drawer>
  );
}
